function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var hoverTime = 50;
var fetchers = {};
var doc = document.implementation.createHTMLDocument('prefetch');
var xhr = new XMLHttpRequest();

function fetchPage(url, success) {
  xhr.open('GET', url);
  xhr.setRequestHeader('VND.PREFETCH', 'true');
  xhr.setRequestHeader('Accept', 'text/html');

  xhr.onreadystatechange = function () {
    if (xhr.readyState !== XMLHttpRequest.DONE) return;
    if (xhr.status !== 200) return;
    success(xhr.responseText);
  };

  xhr.send();
}

function prefetchTurbolink(url) {
  fetchPage(url, function (responseText) {
    doc.open();
    doc.write(responseText);
    doc.close();
    var snapshot = Turbolinks.Snapshot.fromHTMLElement(doc.documentElement);
    Turbolinks.controller.cache.put(url, snapshot);
  });
}

function prefetch(url) {
  if (prefetched(url)) return;
  prefetchTurbolink(url);
}

function prefetched(url) {
  return location.href === url || Turbolinks.controller.cache.has(url);
}

function prefetching(url) {
  return !!fetchers[url];
}

function cleanup(event, href) {
  var element = event.target;
  clearTimeout(fetchers[href]);
  fetchers[href] = null;
  element.removeEventListener('mouseleave', mouseleave);
}

function mouseleave(event, href) {
  xhr.abort();
  cleanup(event, href);
}

function mouseover(event) {
  var target = event.target;
  if (target.hasAttribute('data-remote')) return;
  if (target.getAttribute('data-prefetch') === 'false') return;
  if (target.getAttribute('target') === '_blank') return;
  var href = target.getAttribute("href") || target.getAttribute("data-prefetch"); // skip no fetch link

  if (!href) return; // skip anchor

  if (href.startsWith('#')) return; // skip outside link

  if (href.includes("://") && !href.startsWith(window.location.origin)) return;
  if (prefetched(href)) return;
  if (prefetching(href)) return;
  cleanup(event, href);
  event.target.addEventListener('mouseleave', function (event) {
    return mouseleave(event, href);
  });
  fetchers[href] = setTimeout(function () {
    return prefetch(href);
  }, hoverTime);
}

var _default = /*#__PURE__*/function () {
  function _default() {
    _classCallCheck(this, _default);
  }

  _createClass(_default, null, [{
    key: "start",
    value: function start() {
      var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      hoverTime = opts['delay'] || 50;

      if (!window.Turbolinks) {
        console.error('window.Turbolinks not found, you must import Turbolinks with global.');
        return;
      }

      document.addEventListener('mouseover', mouseover);
    }
  }]);

  return _default;
}();

export { _default as default };